import React from "react";

const LoadingPage = () => (
  <div className="loader">
    <div>
      <img
        className="loader__image"
        src="https://media.giphy.com/media/hL9q5k9dk9l0wGd4e0/giphy.gif"
        alt="gif"
      />
    </div>
  </div>
);

export default LoadingPage;
